import { render, staticRenderFns } from "./NakedMain.vue?vue&type=template&id=00736a4d&scoped=true&"
import script from "./NakedMain.vue?vue&type=script&lang=js&"
export * from "./NakedMain.vue?vue&type=script&lang=js&"
import style0 from "./NakedMain.vue?vue&type=style&index=0&id=00736a4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00736a4d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
